//#region import bloc
import { SCAttributes } from "../../generic/generic-sc-attributes";
import { SCKpis } from "../../generic/generic-sc-domain";
import { IExportColumn } from "../../salescredit/salescredit-types";
//#endregion

const salesTeam = "Sales Team";

//#region Sales Credit
function CAndCFields() {
  return [
    {
      field: SCAttributes.SC_EVENTS_COUNT,
      headerName: "C&C Events Count",
    },
    {
      field: SCAttributes.SC_EXANTE_FINANCIALINSTRUMENT_ONEOFF,
      headerName: "C&C ExAnte Financial Instrument OneOff",
    },
    {
      field: SCAttributes.SC_EXANTE_FINANCIALINSTRUMENT_ONGOING,
      headerName: "C&C ExAnte Financial Instrument OnGoing",
    },
    {
      field: SCAttributes.SC_EXANTE_SERVICE_ONEOFF,
      headerName: "C&C ExAnte Service OneOff",
    },
    {
      field: SCAttributes.SC_EXANTE_SERVICE_ONGOING,
      headerName: "C&C ExAnte Service OnGoing",
    },
    {
      field: SCAttributes.SC_EXANTE_SERVICE_TRANSACTION,
      headerName: "C&C ExAnte Service Transaction",
    },
    {
      field: SCAttributes.SC_EXPOST_FINANCIALINSTRUMENT_ONEOFF,
      headerName: "C&C ExPost Financial Instrument OneOff",
    },
    {
      field: SCAttributes.SC_EXPOST_FINANCIALINSTRUMENT_ONGOING,
      headerName: "C&C ExPost Financial Instrument OnGoing",
    },
    {
      field: SCAttributes.SC_EXPOST_SERVICE_ONEOFF,
      headerName: "C&C ExPost Service OneOff",
    },
    {
      field: SCAttributes.SC_EXPOST_SERVICE_ONGOING,
      headerName: "C&C ExPost Service OnGoing",
    },
    {
      field: SCAttributes.SC_EXPOST_SERVICE_TRANSACTION,
      headerName: "C&C ExPost Service Transaction",
    },
  ];
}
// tslint:disable-next-line: no-big-function
export function SalesCreditDealExportAttribute(): IExportColumn[] {
  return [
    { field: SCAttributes.SC_CREDIT_DATE, headerName: "Deal Credit Date" },
    { field: SCAttributes.SC_MARK_BUSTYPE, headerName: "Business Type" },
    { field: SCAttributes.SC_FPV_BUMNEMO, headerName: "Business Unit" },
    { field: SCAttributes.SC_MARKDEALS_COMMITMENTS, headerName: "Comment" },
    { field: SCAttributes.SC_MARKDEALS_DEAL_CODE, headerName: "Deal Code" },
    { field: SCAttributes.SC_MARKDEALS_ELIOTLOGIN, headerName: "Eliot Login" },
    { field: SCAttributes.SC_MARKDEALS_FILE_CODE, headerName: "File code" },
    {
      field: SCAttributes.SC_CLIENT_LE_CTRY_NAME,
      headerName: "Final Client-Comm Country LE",
    },
    {
      field: SCAttributes.SC_CLIENT_LENAME,
      headerName: "Final Comm Legal Entity",
    },
    {
      field: SCAttributes.SC_CLIENT_LEID,
      headerName: "Final Comm Legal Entity Id",
    },
    {
      field: SCAttributes.SC_MARKDEALS_INPUT_DEAL_CODE,
      headerName: "Input Deal Code",
    },
    { field: SCAttributes.SC_ACTIVITY_NAME, headerName: "Activity Name" },
    { field: SCAttributes.SC_MARK_IS_ELEC, headerName: "Is Elec" },
    { field: SCAttributes.SC_MARKDEALS_MARKET_TYPE, headerName: "Market Type" },
    {
      field: SCAttributes.SC_MARKDEALS_MATURITY_DATE,
      headerName: "Maturity Date",
    },
    { field: SCAttributes.SC_MARKDEALS_MEDIA_CODE, headerName: "Media Code" },
    {
      field: SCAttributes.SC_FPV_GOP,
      headerName: "Sales Operating Group (GOP)",
    },
    {
      field: SCAttributes.SC_MARKDEALS_PACKAGE_CODE,
      headerName: "Package Code",
    },
    {
      field: SCAttributes.SC_MARKDEALS_PRIMARY_SECONDARY,
      headerName: "Primary Secondary",
    },
    {
      field: SCAttributes.SC_MARKDEALS_PRODUCT_NAME,
      headerName: "Product Name",
    },
    { field: SCAttributes.SC_FPV_PCMNEMO, headerName: "Profit Center" },
    { field: SCAttributes.SC_MARKDEALS_QUANTITY, headerName: "Quantity" },
    {
      field: SCAttributes.SC_MARKDEALS_SALES_AUTHOR,
      headerName: "Sales Author",
    },
    { field: SCAttributes.SC_TICKER, headerName: "Sales Credit Ticker" },
    { field: SCAttributes.SC_SALESBEN_SALES, headerName: "Sales Name" },
    { field: SCAttributes.SC_SALESBEN_TEAM, headerName: salesTeam },
    {
      field: SCAttributes.SC_SALESBEN_TEAM_LNAME,
      headerName: "Sales Team Desc",
    },
    {
      field: SCAttributes.SC_MARKDEALS_SCORE_UPDATED_DATE,
      headerName: "SCR Update date",
    },
    {
      field: SCAttributes.SC_SOURCE_APP_MNEMO,
      headerName: "Source Application ",
    },
    { field: SCAttributes.SC_FPV_SBUMNEMO, headerName: "Sub Business Unit" },
    {
      field: SCAttributes.SC_MARKDEALS_SUB_DEAL_TYPE_NAME,
      headerName: "Sub Deal Type",
    },
    { field: SCAttributes.SC_MARKDEALS_TRADE_DATE, headerName: "Trade Date" },
    {
      field: SCAttributes.SC_FPV_TRADE_GOP,
      headerName: "Trader Operating Group (GOP)",
    },
    { field: SCAttributes.SC_FPV_TRADE_PC, headerName: "Trader Profit Center" },
    { field: SCAttributes.SC_FPV_TRADE_LABEL, headerName: "Trader PC Label" },
    {
      field: SCAttributes.SC_MARKDEALS_UNDERLYING_CODE,
      headerName: "Underlying Name",
    },
    { field: SCAttributes.SC_MARKDEALS_VALUE_DATE, headerName: "Value Date" },
    { field: SCAttributes.SC_MARKDEALS_WAY, headerName: "Way" },
    { field: SCAttributes.SC_PRODUCT_LEVEL1, headerName: "Product Level 1" },
    { field: SCAttributes.SC_PRODUCT_LEVEL2, headerName: "Product Level 2" },
    { field: SCAttributes.SC_PRODUCT_LEVEL3, headerName: "Product Level 3" },
    { field: SCAttributes.SC_PRODUCT_LEVEL4, headerName: "Product Level 4" },
    {
      field: SCAttributes.SC_CLIENT_TYPOLOGY_LEVEL2,
      headerName: "Client Typology Level 2",
    },
    {
      field: SCAttributes.SC_CLIENT_TYPOLOGY_LEVEL3,
      headerName: "Client Typology Level 3",
    },
    { field: SCAttributes.SC_FPV_BUSINESS_L1, headerName: "Business Level 1" },
    { field: SCAttributes.SC_FPV_BUSINESS_L2, headerName: "Business Level 2" },
    { field: SCAttributes.SC_FPV_BUSINESS_L3, headerName: "Business Level 3" },
    {
      field: SCAttributes.SC_CLIENT_EC_LEGAL_ID,
      headerName: "Final EC Legal Entity Id",
    },
    {
      field: SCAttributes.SC_CLIENT_EC_FULLNAME,
      headerName: "Final EC Legal Entity",
    },
    {
      field: SCAttributes.SC_MANDATE_COUNTRY,
      headerName: "Mandate Country",
    },
    {
      field: SCAttributes.SC_MANDATE_ZONE,
      headerName: "Mandate Zone",
    },
    {
      field: SCAttributes.SC_MANDATE_REGION,
      headerName: "Mandate Region",
    },
    {
      field: SCAttributes.SC_FINAL_CLIENT_FOLOWUP_CLASS_NAME,
      headerName: "Final Client Follow_up ClassName",
    },
    {
      field: SCAttributes.SC_PRODUCT_CATEGORY_NAME,
      headerName: "Product Category Name",
    },
    {
      field: SCAttributes.SC_DR_NAME,
      headerName: "DR Name",
    },
    {
      field: SCAttributes.SC_INVESTMENT_PURPOSE,
      headerName: "Investment Purpose",
    },
    {
      field: SCAttributes.SC_FINAL_CLIENT_CAMBIST_NAME,
      headerName: "Final Client EC Cambist Name",
    },
    {
      field: SCAttributes.SC_FINAL_CLIENT_MIFID_CATEGORY,
      headerName: "Final Client MIFID Category (LE)",
    },
    {
      field: SCAttributes.SC_ISSUER_NAME,
      headerName: "Issuer Name",
    },
    ...CAndCFields(),
    { field: SCAttributes.SC_CLIENT_GRPID, headerName: "Final Com Grp Id" },
    {
      field: SCAttributes.SC_CLIENT_GROUPNAME,
      headerName: "Final Com Grp Name",
    },
    { field: SCAttributes.SC_SUB_GRP_ID, headerName: "Final Com SubGrp Id" },
    {
      field: SCAttributes.SC_CLIENT_SUBGROUPNAME,
      headerName: "Final Com SubGrp Name",
    },
    { field: SCAttributes.SC_OE_SHORT_LABEL, headerName: "Originating Entity" },
    {
      field: SCAttributes.SC_OE_RES_CTRY_NAME,
      headerName: "Originating Country",
    },
    {
      field: SCAttributes.SC_OE_RES_REG_CODE,
      headerName: "Originating Region",
    },
    { field: SCAttributes.SC_BE_SHORT_LABEL, headerName: "Booking Entity" },
    { field: SCAttributes.SC_FPV_SALES_REGION, headerName: "Sales Region" },
    { field: SCAttributes.SC_FPV_SALES_ZONE, headerName: "	Sales Zone" },
    { field: SCAttributes.SC_FPV_SALES_COUNTRY, headerName: "Sales Country" },
    {
      field: SCAttributes.SC_GOP_LABEL,
      headerName: "Sales Operating Group Label (GOP)",
    },
    {
      field: SCAttributes.SC_BE_SHORT_MNEMO,
      headerName: "Booking Entity Mnemo",
    },
    {
      field: SCAttributes.SC_CLI_GRP_TYPEL1,
      headerName: "Client - Group - Typology Level 1",
    },
    {
      field: SCAttributes.SC_CLI_GRP_COM_REG_NAME,
      headerName: "Client - Group - Region Name",
    },
    {
      field: SCAttributes.SC_CLI_GRP_CTRY,
      headerName: "Client - Group - Country Name",
    },

    {
      field: SCAttributes.SC_CLIENT_LE_TYPO_L1,
      headerName: "Client - LE - Typology Level 1",
    },
    {
      field: SCAttributes.SC_CLIENT_LE_TYPEL2_NAME,
      headerName: "Client - LE - Typology Level 2",
    },
    {
      field: SCAttributes.SC_CLIENT_LE_TYPEL3_NAME,
      headerName: "Client - LE - Typology Level 3",
    },

    {
      field: SCAttributes.SC_CLIENT_LE_REG_NAME,
      headerName: "Client - LE - Region Name",
    },
    {
      field: SCAttributes.SC_CLIENT_LE_SUBREG_NAME,
      headerName: "Client - LE - Sub Region Name",
    },
    {
      field: SCAttributes.SC_CLIENT_LE_CTRY_GRP_NAME,
      headerName: "Client - LE - Country Grouping Name",
    },
    {
      field: SCAttributes.SC_TRADE_BE_SHORT_MNEMO,
      headerName: "Trader Booking Entity Mnemo",
    },
    {
      field: SCAttributes.SC_TRADE_SBU,
      headerName: "Trader Sub Business Unit",
    },
    {
      field: SCAttributes.SC_TRADE_SUB_MNEMO,
      headerName: "Trader Sub Business Unit Mnemo",
    },

    {
      field: SCAttributes.SC_TRADE_SSBL,
      headerName: "Trader Sub Sub Business Line",
    },
    {
      field: SCAttributes.SC_SALESBEN_BUNAME,
      headerName: "Sales Business Unit",
    },
    {
      field: SCAttributes.SC_PO_GRP_FULLNAME,
      headerName: "Primary Obligor Group Name",
    },
    {
      field: SCAttributes.SC_PO_GRP_ID,
      headerName: "Primary Obligor Group ID",
    },
    {
      field: SCAttributes.SC_PO_GRP_CTRY_NAME,
      headerName: "Primary Obligor Group Country",
    },
    {
      field: SCAttributes.SC_MARKDEALS_PRODUCT_FAMILY_NAME,
      headerName: "Product Family Name",
    },
    {
      field: SCAttributes.SC_DEAL_X_ONE_INSTRUMENT,
      headerName: "Deal - X-One Instrument",
    },
    {
      field: SCAttributes.SC_MARKDEALS_EQYFI,
      headerName: "Equity/fixed Income Deals",
    },
    {
      field: SCAttributes.SC_MARK_NOMINAL_CURRENCY,
      headerName: "Nominal Currency",
    },
    { field: SCAttributes.SC_AGENCY_DR_NAME, headerName: "Agency DR Name" },
    {
      field: SCAttributes.SC_PO_LE_FULLNAME,
      headerName: "Primary Obligor - LE - Name",
    },
    {
      field: SCAttributes.SC_PO_LE_ID,
      headerName: "Primary Obligor - LE - BDR CCIAL ID",
    },
    {
      field: SCAttributes.SC_CLI_MARK_CURRENCY_EMG10,
      headerName: "Deal Currency EM/G10",
    },
    {
      field: SCAttributes.SC_CLI_MARK_CURRENCY_ZONES,
      headerName: "Deal Currency Zones",
    },
    {
      field: SCAttributes.SC_CLI_MARK_CURRENCY,
      headerName: "Deal Currency",
    },
  ];
}
export function SalesCreditDealExportKpi(): IExportColumn[] {
  return [
    { field: SCKpis.SC_SC, headerName: "SC (Euro)" },
    { field: SCKpis.SC_USD, headerName: "SC (USD)" },
    { field: SCKpis.SC_CVA_FEE_EURO, headerName: "CVA (Euro)" },
    { field: SCKpis.SC_F2Y_EURO, headerName: "F(Y) (Euro)" },
    { field: SCKpis.SC_MARKUP_EURO, headerName: "Markup (Euro)" },
    { field: SCKpis.SC_NOMINAL_YTD_EURO, headerName: "Nominal (Euro)" },
    {
      field: SCKpis.SC_MARK_UP_NET_CVA_S1,
      headerName: "Mark-up net cva S1",
    },
    { field: SCKpis.SC_YOY_PER, headerName: "SC var YoY" },
    { field: SCKpis.SC_BUDGET_SALES, headerName: "Budget Sales" },
    { field: SCKpis.SC_BUDGET_TEAM, headerName: "Budget Team" },
    { field: SCKpis.SC_BUDGET_PC, headerName: "Budget Profit Center" },
    {
      field: SCKpis.SC_BUDGET_SBU,
      headerName: "Budget Sub Business Unit",
    },
    { field: SCAttributes.SC_BUDGET_BU, headerName: "Budget Business Unit" },
  ];
}
export function SalesCreditExportcolumns(): IExportColumn[] {
  const attributes = SalesCreditDealExportAttribute();
  const kpis = SalesCreditDealExportKpi();
  return attributes.concat(kpis);
}

export function DefaultSalesCreditExportcolumns(): IExportColumn[] {
  return [
    { field: SCAttributes.SC_CREDIT_DATE, headerName: "Deal Credit Date" },
    { field: SCAttributes.SC_MARKDEALS_DEAL_CODE, headerName: "Deal Code" },
    {
      field: SCAttributes.SC_CLIENT_LE_CTRY_NAME,
      headerName: "Final Client-Comm Country LE",
    },
    {
      field: SCAttributes.SC_CLIENT_LENAME,
      headerName: "Final Comm Legal Entity",
    },
    { field: SCAttributes.SC_ACTIVITY_NAME, headerName: "Activity Name" },
    {
      field: SCAttributes.SC_MARKDEALS_PRODUCT_NAME,
      headerName: "Product Name",
    },
    { field: SCAttributes.SC_SALESBEN_SALES, headerName: "Sales Name" },
    { field: SCAttributes.SC_SALESBEN_TEAM, headerName: salesTeam },
    { field: SCAttributes.SC_FPV_SBUMNEMO, headerName: "Sub Business Unit" },
    { field: SCKpis.SC_SC, headerName: "SC (Euro)" },
    {
      field: SCAttributes.SC_MARKDEALS_UNDERLYING_CODE,
      headerName: "Underlying Name",
    },
  ];
}
//#endregion

// tslint:disable-next-line: no-big-function
export function sc_clientList_attributes(): IExportColumn[] {
  return [
    { field: SCAttributes.SC_CLIENT_LEID, headerName: "Final Com LE Id" },
    { field: SCAttributes.SC_CLIENT_LENAME, headerName: "Final Com LE Name" },
    { field: SCAttributes.SC_SUB_GRP_ID, headerName: "Final Com SubGrp Id" },
    {
      field: SCAttributes.SC_CLIENT_SUBGROUPNAME,
      headerName: "Final Com SubGrp Name",
    },
    { field: SCAttributes.SC_CLIENT_GRPID, headerName: "Final Com Grp Id" },
    {
      field: SCAttributes.SC_CLIENT_GROUPNAME,
      headerName: "Final Com Grp Name",
    },
    {
      field: SCAttributes.SC_CLIENT_EC_FULLNAME,
      headerName: "Final Com EC Name",
    },
    {
      field: SCAttributes.SC_CLIENT_EC_COM_ID,
      headerName: "Final Com EC Id",
    },
    {
      field: SCAttributes.SC_CLIENT_EC_COM_CTRY,
      headerName: "Client EC country",
    },
    { field: SCAttributes.SC_PRODUCT_LEVEL1, headerName: "Product Level 1" },
    { field: SCAttributes.SC_PRODUCT_LEVEL2, headerName: "Product Level 2" },
    { field: SCAttributes.SC_PRODUCT_LEVEL3, headerName: "Product Level 3" },
    {
      field: SCAttributes.SC_FPV_TRADE_SUBMNEMO,
      headerName: "Trader Sub Business Unit Mnemo",
    },
    {
      field: SCAttributes.SC_FPV_TRADE_LABEL,
      headerName: "Trader Profit Center",
    },
    {
      field: SCAttributes.SC_FPV_TRADE_PC,
      headerName: "Trader Profit Center Mnemo",
    },
    {
      field: SCAttributes.SC_CLIENT_LE_CTRY_NAME,
      headerName: "Client Country",
    },
    { field: SCAttributes.SC_SALESBEN_SALES, headerName: "Sales" },
    { field: SCAttributes.SC_SALESBEN_TEAM, headerName: salesTeam },
    {
      field: SCAttributes.SC_FPV_TRADE_SSBL,
      headerName: "Trader Sub Sub Business Line",
    },
    {
      field: SCAttributes.SC_FPV_TRADE_SBU,
      headerName: "Trader Sub Business Unit",
    },
    {
      field: SCAttributes.SC_FPV_SSBL,
      headerName: "Sales Sub Sub Business Line",
    },
    {
      field: SCAttributes.SC_FPV_LABEL,
      headerName: "Sales Profit Center",
    },
    {
      field: SCAttributes.SC_FPV_PCMNEMO,
      headerName: "Sales Profit Center Mnemo",
    },
    {
      field: SCAttributes.SC_OE_RES_REG_CODE,
      headerName: "Originating Region",
    },
    {
      field: SCAttributes.SC_BE_SHORT_LABEL,
      headerName: "Booking Entity",
    },
    {
      field: SCAttributes.SC_FPV_GOP,
      headerName: "Sales Operating Group",
    },
    {
      field: SCAttributes.SC_FPV_SALES_REGION,
      headerName: "Sales Region",
    },
    {
      field: SCAttributes.SC_FPV_SALES_ZONE,
      headerName: "Sales Zone",
    },
    {
      field: SCAttributes.SC_FPV_SALES_COUNTRY,
      headerName: "Sales Country",
    },
    {
      field: SCAttributes.SC_FPV_BUSINESS_L1,
      headerName: "Business Level 1",
    },
    {
      field: SCAttributes.SC_FPV_BUSINESS_L2,
      headerName: "Business Level 2",
    },
    {
      field: SCAttributes.SC_FPV_BUSINESS_L3,
      headerName: "Business Level 3",
    },
    {
      field: SCAttributes.SC_BE_SHORT_MNEMO,
      headerName: "Booking Entity Mnemo",
    },
    {
      field: SCAttributes.SC_CLIENT_LE_TYPO_L1,
      headerName: "Client - LE - Typology Level 1",
    },
    {
      field: SCAttributes.SC_CLIENT_LE_TYPEL2_NAME,
      headerName: "Client - LE - Typology Level 2",
    },
    {
      field: SCAttributes.SC_CLIENT_LE_TYPEL3_NAME,
      headerName: "Client - LE - Typology Level 3",
    },
    {
      field: SCAttributes.SC_CLIENT_LE_REG_NAME,
      headerName: "Client - LE - Region Name",
    },
    {
      field: SCAttributes.SC_CLIENT_LE_SUBREG_NAME,
      headerName: "Client - LE - Sub Region Name",
    },
    {
      field: SCAttributes.SC_CLIENT_LE_CTRY_GRP_NAME,
      headerName: "Client - LE - Country Grouping Name",
    },
    {
      field: SCAttributes.SC_FINAL_CLIENT_CAMBIST_NAME,
      headerName: "Client - EC - Cambist Name",
    },
    {
      field: SCAttributes.SC_MARK_BUSTYPE,
      headerName: "Business Type",
    },
    {
      field: SCAttributes.SC_TRADE_BE_SHORT_MNEMO,
      headerName: "Trader Booking Entity Mnemo",
    },
    {
      field: SCAttributes.SC_PRODUCT_CATEGORY_NAME,
      headerName: "Product Category Name",
    },
    {
      field: SCAttributes.SC_PRODUCT_LEVEL4,
      headerName: "Product Level 4",
    },
    {
      field: SCAttributes.SC_MARKDEALS_PRODUCT_FAMILY_NAME,
      headerName: "Product Family Name",
    },
    {
      field: SCAttributes.SC_MARKDEALS_EQYFI,
      headerName: "Equity/fixed Income Deals",
    },
    {
      field: SCAttributes.SC_MARK_NOMINAL_CURRENCY,
      headerName: "Nominal Currency",
    },
    {
      field: SCAttributes.SC_MARK_NEGOTIATED_CURRENCY,
      headerName: "Negotiated Currency",
    },
    {
      field: SCAttributes.SC_MANDATE_COUNTRY,
      headerName: "Mandate Country",
    },
    {
      field: SCAttributes.SC_MANDATE_REGION,
      headerName: "Mandate Region",
    },
    {
      field: SCAttributes.SC_MANDATE_ZONE,
      headerName: "Mandate Zone",
    },
    {
      field: SCAttributes.SC_MARK_IS_ELEC,
      headerName: "Is Elec",
    },
    {
      field: SCAttributes.SC_AGENCY_DR_NAME,
      headerName: "Agency DR Name",
    },
    {
      field: SCAttributes.SC_CLI_MARK_CURRENCY_EMG10,
      headerName: "Deal Currency EM/G10",
    },
    {
      field: SCAttributes.SC_CLI_MARK_CURRENCY_ZONES,
      headerName: "Deal Currency Zones",
    },
    {
      field: SCAttributes.SC_CLI_MARK_CURRENCY,
      headerName: "Deal Currency",
    },
    {
      field: SCAttributes.SC_FPV_SBUMNEMO,
      headerName: "Sales - sub business unit",
    },
    {
      field: SCAttributes.SC_FPV_TRADE_INVFLOWFIN,
      headerName: "FPV Trd - Inv. Sol./Flow/Fin.",
    },
    {
      field: SCAttributes.SC_TEAM_ACTIVITY,
      headerName: "Team Activity Label",
    },
    {
      field: SCAttributes.SC_TEAM_DESK,
      headerName: "Team Desk Label",
    },
    {
      field: SCAttributes.SALESBEN_SALES_LOCATION,
      headerName: "Sales Location",
    },
    {
      field: SCAttributes.SC_DEAL_X_ONE_INSTRUMENT,
      headerName: "Deal - X-One Instrument",
    },
  ];
}
const scYtdVarYoy = "sc_ytd_var_yoy";
export function sc_clientList_kpis(): IExportColumn[] {
  return [
    { field: SCKpis.SC_YTD, headerName: "SC YTD (K€)" },
    {
      field: SCKpis.SC_YTD_1,
      headerName: "SC YTD-1 (K€)",
    },
    { field: SCKpis.SC_YTD_USD, headerName: "SC YTD (K$)" },
    {
      field: SCKpis.SC_YTD_USD_1,
      headerName: "SC YTD-1 (K$)",
    },
    { field: SCKpis.SC_NOMINAL_YTD, headerName: "Nominal" },
    { field: SCKpis.SC_FY, headerName: "SC FY" },
    {
      field: SCKpis.SC_FY_1,
      headerName: "SC FY-1",
    },
    { field: SCKpis.SC_VOLUMES_YTD, headerName: "Volumes YTD" },
    { field: SCKpis.SC_VOLUMES_YTD_1, headerName: "Volumes YTD-1" },
    { field: scYtdVarYoy, headerName: "SC YTD var YoY" },
    {
      field: SCKpis.SC_MTD,
      headerName: "SC MTD (K€)",
    },
    {
      field: SCKpis.SC_MTD_1,
      headerName: "SC MTD-1 (K€)",
    },
    {
      field: SCKpis.SC_MTD_YOY,
      headerName: "SC MTD var (%)",
    },

    {
      field: SCKpis.SC_YTD_2,
      headerName: "SC YTD-2 (K€)",
    },
    {
      field: SCKpis.SC_YTD_3,
      headerName: "SC YTD-3 (K€)",
    },
    {
      field: SCKpis.SC_BUDGET_SALES,
      headerName: "Budget Sales",
    },
    {
      field: SCKpis.SC_BUDGET_TEAM,
      headerName: "Budget Team",
    },
    {
      field: SCKpis.SC_BUDGET_PC,
      headerName: "Budget Profit Center",
    },
    {
      field: SCKpis.SC_BUDGET_SBU,
      headerName: "Budget Sub Business Unit",
    },
    {
      field: SCKpis.SC_BUDGET_BU,
      headerName: "Budget Business Unit",
    },
    {
      field: SCKpis.SC_MTD_STEP1,
      headerName: "SC MTD Step 1",
    },
    {
      field: SCKpis.SC_SC_2,
      headerName: "SC FY-2",
    },
    {
      field: SCKpis.SC_COM_YTD,
      headerName: "Commission YTD",
    },
    {
      field: SCKpis.SC_COM_YTD_1,
      headerName: "Commission YTD-1",
    },
    {
      field: SCKpis.SC_CSA_YTD,
      headerName: "CSA YTD",
    },
    {
      field: SCKpis.SC_CSA_YTD_1,
      headerName: "CSA YTD-1",
    },
    {
      field: SCKpis.SC_FEES_YTD,
      headerName: "Fees YTD",
    },
    {
      field: SCKpis.SC_FEES_YTD_1,
      headerName: "Fees YTD-1",
    },
    {
      field: SCKpis.SC_TRADPL_YTD,
      headerName: "Trading Pnl YTD",
    },
    {
      field: SCKpis.SC_TRADPL_YTD_1,
      headerName: "Trading Pnl YTD-1",
    },
    {
      field: SCKpis.SC_MARKUP_YTD,
      headerName: "YTD Mark Up",
    },
  ];
}
export function scComputedKpis() {
  return [scYtdVarYoy];
}
export function sc_clientList_columns(): IExportColumn[] {
  const attributes = sc_clientList_attributes();
  const kpis = sc_clientList_kpis();
  return attributes.concat(kpis);
}

export function sc_clientList_default_attributes(): IExportColumn[] {
  const defaultAttributes = [
    SCAttributes.SC_CLIENT_LENAME,
    SCAttributes.SC_PRODUCT_LEVEL1,
    SCAttributes.SC_PRODUCT_LEVEL2,
    SCAttributes.SC_PRODUCT_LEVEL3,
  ];
  return sc_clientList_columns().filter(
    x => defaultAttributes.indexOf(x.field) > -1
  );
}

export function sc_clientList_default_kpis(): IExportColumn[] {
  // TO_DO: default columns need to be decided
  const defaultKpis = [SCKpis.SC_YTD, SCKpis.SC_YTD_1];
  return sc_clientList_columns().filter(x => defaultKpis.indexOf(x.field) > -1);
}

export function sc_clientList_default_columns(): IExportColumn[] {
  // TO_DO: default columns need to be decided
  const attributes = sc_clientList_default_attributes();
  const kpis = sc_clientList_default_kpis();
  return attributes.concat(kpis);
}
